import { isNewCampaignForAgent } from ".";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { FEATURES_KEYS, FEATURES_NEW_FEATURE_CAMPAIGNS, Features } from "constants/features";
import { PRODUCTS_KEYS, PRODUCTS_NEW_FEATURE_CAMPAIGNS, Product } from "constants/product";
import { REPORTS_NEW_FEATURE_CAMPAIGNS, REPORT_TYPE_KEYS, ReportType } from "constants/reports/report-type";
import { SETTINGS_NEW_FEATURE_CAMPAIGNS, SETTINGS_SECTION_KEYS, SettingsSection } from "constants/settings/sections";
import { useAgentFlag } from "hooks/use-agent-flag";
import { selectLoggedInAgent } from "store/entities/agents";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const findFlagName = (section: SettingsSection | Product | Features | ReportType) => {
  if (section in SETTINGS_SECTION_KEYS) {
    return SETTINGS_SECTION_KEYS[section as keyof typeof SETTINGS_SECTION_KEYS];
  }
  if (section in PRODUCTS_KEYS) {
    return PRODUCTS_KEYS[section as keyof typeof PRODUCTS_KEYS];
  }
  if (section in FEATURES_KEYS) {
    return FEATURES_KEYS[section as keyof typeof FEATURES_KEYS];
  }
  if (section in REPORT_TYPE_KEYS) {
    return REPORT_TYPE_KEYS[section as keyof typeof REPORT_TYPE_KEYS];
  }
  return undefined;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const findCampaigns = (section: SettingsSection | Product | Features | ReportType) => {
  if (section in SETTINGS_NEW_FEATURE_CAMPAIGNS) {
    return SETTINGS_NEW_FEATURE_CAMPAIGNS[section as SettingsSection];
  }
  if (section in PRODUCTS_NEW_FEATURE_CAMPAIGNS) {
    return PRODUCTS_NEW_FEATURE_CAMPAIGNS[section as Product];
  }
  if (section in FEATURES_NEW_FEATURE_CAMPAIGNS) {
    return FEATURES_NEW_FEATURE_CAMPAIGNS[section as Features];
  }
  if (section in REPORT_TYPE_KEYS) {
    return REPORTS_NEW_FEATURE_CAMPAIGNS[section as ReportType];
  }
  return [];
};

export default function useNewFeaturesInformation(section: SettingsSection | Product | Features | ReportType): boolean {
  const agent = useSelector(selectLoggedInAgent);
  const flagName = findFlagName(section);

  const lastVisitedDate = useAgentFlag(flagName)[0] || agent?.createdAt;

  const campaigns = findCampaigns(section);

  return useMemo(
    () => campaigns?.find(campaign => isNewCampaignForAgent(agent?.createdAt, lastVisitedDate, campaign)) !== undefined,
    [agent?.createdAt, campaigns, lastVisitedDate]
  );
}
